import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/css/main.css'
import { currency } from './commons/currency'
import { display_date, order_status, order_status_color, order_status_text_color, vip_level, vip_level_color, capitalize, display_value, display_color, display_text_color } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
import VueMuuriGrid from 'vue-muuri-grid'
import HighchartsVue from 'highcharts-vue'

Vue.use(VueResource);
Vue.use(require('vue-shortkey'))
Vue.use(VueMuuriGrid);
Vue.use(HighchartsVue);
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('order_status', order_status)
Vue.filter('order_status_color', order_status_color)
Vue.filter('order_status_text_color', order_status_text_color)
Vue.filter('vip_level', vip_level)
Vue.filter('vip_level_color', vip_level_color)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
